import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-4" }
const _hoisted_7 = { class: "fw-normal" }
const _hoisted_8 = { class: "d-flex mt-4 justify-content-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload fs-2 text-white" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-magic fs-2" }, null, -1)
const _hoisted_11 = { class: "col-sm-7" }
const _hoisted_12 = {
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_13 = { class: "alert-heading" }
const _hoisted_14 = { class: "fw-normal my-6" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-light-success border border-success"
}
const _hoisted_16 = {
  key: 1,
  class: "badge badge-light-danger border border-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_btnDownload = _resolveComponent("btnDownload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t('photography')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.t('preview')), 1),
          _withDirectives(_createVNode(_component_el_avatar, {
            size: 100,
            shape: "square",
            class: "w-100 h-400px",
            fit: 'fit',
            src: `${_ctx.urlServerFile}/${_ctx.photo.ruta}`
          }, null, 8, ["src"]), [
            [_directive_loading, _ctx.loader]
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.photo.ruta)
              ? (_openBlock(), _createBlock(_component_btnDownload, {
                  key: 0,
                  resource: _ctx.photo.ruta,
                  "name-file": _ctx.photo?.idphoto
                }, null, 8, ["resource", "name-file"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "subir",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _ctx.onDialogPhoto,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "Remover fondo",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeBg(_ctx.photo?.idphoto)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.t('recommendations')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.t('photo1')), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.t('photo2')), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.t('photo3')), 1)
            ])
          ]),
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.t('photoHistory')), 1),
          _createVNode(_component_el_table, {
            data: _ctx.photoList,
            style: {"width":"100%"},
            "max-height": "250",
            "table-layout": 'auto',
            border: "",
            "highlight-current-row": "",
            onCurrentChange: _ctx.handleCurrentChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "idphoto",
                width: "70",
                label: "ID",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "ruta",
                label: "RUTA",
                width: "auto"
              }),
              _createVNode(_component_el_table_column, {
                label: "ESTADO",
                width: "110"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.mstatus == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Activo"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "Archivado"))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onCurrentChange"])
        ])
      ])
    ])
  ]))
}